module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ../~/fbjs/~/core-js/library/modules/$.redefine.js
// module id = 346
// module chunks = 17